<template>
  <v-tooltip bottom content-class="tooltip-bottom">
    <template #activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on" class="notification-status-toggle">
        <v-switch
          class="notification-status-toggle__switch"
          dense
          inset
          hide-details
          :input-value="value"
          :disabled="disabled || loading"
          :loading="loading"
          :aria-label="tooltipText"
          :data-testid="switchTestid"
          @change="$emit('change', $event)"
        />
      </div>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
import { EMAIL_NOTIFICATION } from '../../../utils/constants';

export default {
  name: 'NotificationStatusToggle',
  props: {
    value: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    dataTestid: { type: String, default: 'notification-status-toggle' },
  },
  computed: {
    tooltipText() {
      return this.value
        ? EMAIL_NOTIFICATION.ACTION_TOOLTIP.DISABLE
        : EMAIL_NOTIFICATION.ACTION_TOOLTIP.ENABLE;
    },
    switchTestid() {
      return this.value ? `${this.dataTestid}--enabled` : `${this.dataTestid}--disabled`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './NotificationStatusToggle.scss';
</style>
